var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIExclMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_8481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00041 17.2894C13.5786 17.2894 17.2899 13.5781 17.2899 8.99992C17.2899 4.42177 13.5786 0.710449 9.00041 0.710449C4.42226 0.710449 0.710938 4.42177 0.710938 8.99992C0.710938 13.5781 4.42226 17.2894 9.00041 17.2894Z",
    fill: "#E55151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7961 10.7147H8.20452L7.90137 4.78418H10.0993L9.7961 10.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85272 11.6621H8.14746V13.3674H9.85272V11.6621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_8481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIExclMark);
export default __webpack_public_path__ + "static/media/i_excl_mark.b4260cd14bc11b7a68b7494e5b6aba1c.svg";
export { ForwardRef as ReactComponent };